import { LEAD_STATUSES as LS } from '@/types';
export const LEAD_STATUSES = LS;

export const APP_NAME = 'GetIntoCollege';
export const APP_URL = 'https://getintocollege.in';
export const SUPPORT_EMAIL = 'support@getintocollege.in';
export const SUPPORT_PHONE = '+91 XXXXX XXXXX';
export const WHATSAPP_NUMBER = '+91XXXXXXXXXX';
export const BUSINESS_HOURS = 'Monday – Saturday, 10:00 AM – 7:00 PM IST';

export const PHONE_REGEX = /^[6-9]\d{9}$/;
export const OTP_LENGTH = 6;
export const OTP_EXPIRY_SECONDS = 300;
export const OTP_RESEND_COOLDOWN_SECONDS = 60;
export const OTP_MAX_ATTEMPTS = 3;
export const OTP_MAX_SENDS = 3;
export const OTP_SEND_WINDOW_MINUTES = 10;
export const OTP_VERIFY_WINDOW_MINUTES = 30;

export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const ALLOWED_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];
export const ALLOWED_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png'];

export const APPLICATION_STEPS = [
  { id: 'phone', label: 'Verify Phone', step: 1 },
  { id: 'personal', label: 'Personal Details', step: 2 },
  { id: 'academic', label: 'Academic Details', step: 3 },
  { id: 'preferences', label: 'Preferences', step: 4 },
  { id: 'documents', label: 'Documents', step: 5 },
  { id: 'review', label: 'Review', step: 6 },
] as const;

export const COURSES = [
  { id: 'engineering', label: 'Engineering', icon: 'Wrench' },
  { id: 'management', label: 'Management', icon: 'Briefcase' },
  { id: 'medical', label: 'Medical & Allied Health', icon: 'HeartPulse' },
  { id: 'computer', label: 'Computer Applications', icon: 'Monitor' },
  { id: 'arts', label: 'Arts & Humanities', icon: 'Palette' },
  { id: 'commerce', label: 'Commerce', icon: 'BarChart3' },
  { id: 'law', label: 'Law', icon: 'Scale' },
  { id: 'pharmacy', label: 'Pharmacy', icon: 'Pill' },
  { id: 'nursing', label: 'Nursing', icon: 'Stethoscope' },
  { id: 'diploma', label: 'Diploma Courses', icon: 'Award' },
  { id: 'distance', label: 'Distance & Online', icon: 'Laptop' },
  { id: 'other', label: 'Other Courses', icon: 'BookOpen' },
];

export const INDIAN_STATES: string[] = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
  'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
  'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Puducherry', 'Chandigarh',
];

export const BUDGET_RANGES = [
  { value: 'under_1_lakh', label: 'Under ₹1 Lakh per year' },
  { value: '1-2_lakhs', label: '₹1 – 2 Lakhs per year' },
  { value: '2-5_lakhs', label: '₹2 – 5 Lakhs per year' },
  { value: '5-10_lakhs', label: '₹5 – 10 Lakhs per year' },
  { value: 'above_10_lakhs', label: 'Above ₹10 Lakhs per year' },
];

export const COLLEGE_TYPES = [
  { value: 'government', label: 'Government' },
  { value: 'private', label: 'Private' },
  { value: 'deemed', label: 'Deemed University' },
  { value: 'autonomous', label: 'Autonomous' },
  { value: 'open', label: 'Open to all' },
];

export const CONTACT_METHODS = [
  { value: 'phone', label: 'Phone' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'email', label: 'Email' },
];

export const ADMISSION_SESSIONS = [
  { value: '2026-2027', label: '2026 – 2027' },
  { value: '2027-2028', label: '2027 – 2028' },
  { value: 'flexible', label: 'Flexible' },
];

export const STUDY_MODES = [
  { value: 'on_campus', label: 'On Campus (Regular)' },
  { value: 'online', label: 'Online / Distance' },
  { value: 'hybrid', label: 'Hybrid' },
];

export const QUALIFICATIONS = [
  { value: '10th', label: '10th Pass' },
  { value: '12th', label: '12th Pass' },
  { value: 'diploma', label: 'Diploma' },
  { value: 'graduate', label: 'Graduate' },
  { value: 'post_graduate', label: 'Post Graduate' },
];

export const DEGREE_LEVELS = [
  { value: 'diploma', label: 'Diploma' },
  { value: 'undergraduate', label: 'Undergraduate (UG)' },
  { value: 'postgraduate', label: 'Postgraduate (PG)' },
  { value: 'doctoral', label: 'Doctoral' },
];

export const ADMIN_ROLES: { value: string; label: string }[] = [
  { value: 'owner', label: 'Owner' },
  { value: 'admin', label: 'Admin' },
  { value: 'counsellor', label: 'Counsellor' },
];
